import { Row, Space, Spin, Table, Tag } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { layDSTaiKhoanTheoIdNhanVien } from '../../services/nguoidung';
import { TaiKhoanResponse } from '../../models/nguoidung/NguoiDung';
import Column from 'antd/es/table/Column';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev={undefined} />;

const AccountTable = ({ idNhanVien, select, onSelect }: { idNhanVien: number, select: any, onSelect: (account: any) => any }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingComponent, setIsLoadingComponent] = useState<boolean>(false);
    const [dsTaiKhoan, setDsTaiKhoan] = useState<Array<TaiKhoanResponse>>([]);

    const getDanhSachTaiKhoan = async (idNhanVien: number) => {
        if (!isLoadingComponent) {
            setIsLoadingComponent(true);
            const data = await layDSTaiKhoanTheoIdNhanVien(idNhanVien);
            setDsTaiKhoan(data);
            setIsLoading(false);
            setIsLoadingComponent(false);
        }
    }

    useEffect(() => {
        getDanhSachTaiKhoan(idNhanVien);
    }, []);
    return (
        <>
            {
                isLoadingComponent ?
                    <Row>
                        <Space className="m-auto">
                            <Spin indicator={antIcon} />
                            Đang tải
                        </Space>
                    </Row> :
                    <>
                        <Table
                            rowSelection={{
                                type: "radio",
                                onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
                                    if (selectedRows.length > 0) {
                                        onSelect(selectedRows[0]);
                                    } else {
                                        onSelect({});
                                    }
                                },
                                selectedRowKeys: [select?.key],
                            }}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            bordered size="small"
                            dataSource={(dsTaiKhoan || []).map((v) => { return { key: idNhanVien + "_" + v.id, ...v } })} pagination={{ position: ["none", "none"] }}>
                            <Column title="Tài khoản" key="taikhoan"
                                render={(value, record, index) =>
                                (
                                    <Space>
                                        {value.tenDangNhap}
                                        {value.isAdmin ? <Tag color="red">Admin</Tag> : null}
                                    </Space>
                                )
                                }
                            />
                            <Column
                                title="Trạng thái"
                                key="trangthai"
                                render={(value, record, index) =>
                                    <Space>
                                        {value.kichHoat ? <Tag color="green">Hoạt động</Tag> : <Tag color="red">Khóa</Tag>}
                                    </Space>
                                }
                            />
                        </Table>
                    </>
            }
        </>
    );
};

export default AccountTable;
